// extracted by mini-css-extract-plugin
export var fileExt = "_sm-8";
export var fileIcon = "_sm-6";
export var fileLink = "_sm-5";
export var fileName = "_sm-7";
export var image = "_sm-1";
export var imageError = "_sm-3";
export var imageErrorIcon = "_sm-4";
export var imageLink = "_sm-0";
export var imageLoaded = "_sm-2";